"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cookbooksQuery = void 0;
const client_1 = require("@apollo/client");
const cookbook_1 = require("../fragments/cookbook");
exports.cookbooksQuery = client_1.gql `
  query Cookbooks {
    cookbooks {
      ...justCookbook
      byName
      accessLevel
    }
  }
  ${cookbook_1.justCookbookFragment}
`;
//# sourceMappingURL=browseCookbook.js.map